<template>
    <div>
        <el-dialog class="productTypeDialog planWordDialog" :before-close="closeDialog" :append-to-body="true" title=""
            :destroy-on-close="true" :show-close="false" :visible.sync="planMapShow" width="50%">
            <createPlanMap v-show="planMapShow && modalShow" id="planMap" class="createPlanMap" ref="createPlanMap"
                @genPixels="genPixels" :citys="mapCityArr"></createPlanMap>
          
            <div style="display: flex">
                <el-button v-show="modalShow"
                    style="width: 100%;border-radius: 0px;background-color: rgb(245, 108, 108);color: white;border: none"
                    @click="screenshot()">请将鼠标放在地图上放大缩小到合适位置时点击此处下载
                </el-button>
                <el-button style="margin-left: 0" @click="planMapShow = false">关闭</el-button>
            </div>

        </el-dialog>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import createPlanMap from '../../mapPlanFlod/createPlanMap.vue'
import { getPlanInfo } from '../../js/function'
import { mapState } from 'vuex'
import html2canvas from 'html2canvas'
import PlanApi from '@/components/Api/PlanApi'

export default {
    name: '',
    components: {
        createPlanMap
    },
    // 定义属性
    data() {
        return {
            modalShow: false,
            planMapShow: false,
            mapCityArr: [],
            chenckBudget: {},
            planMapPic: "",
            pixels: []
        }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
        ...mapState(['planId']),
        ...mapState(['budgetMainId'])
    },
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        closeDialog() {
            this.$emit("closeDialog")
        },
        //像素点的生成
        genPixels(pixels) {
            this.pixels = pixels
            console.log('像素点的生成', this.pixels)
        },
        screenshot() {
            if (this.mapCityArr.length <= 1) {
                this.$emit("allowExport")
                return
            }
            const shareContent = document.getElementById("planMap")

            const canvas = document.createElement('canvas')
            if (shareContent) {
                // 获取父级的宽高
                const width = parseInt(window.getComputedStyle(shareContent).width)
                const height = parseInt(window.getComputedStyle(shareContent).height)
                console.log("canvas::", width, height)
                canvas.style.width = '1980px'
                canvas.style.height = '800px'
                const options = {
                    // foreignObjectRendering: true,
                    taintTest: true, // 检测每张图片都已经加载完成
                    useCORS: true, // 跨域处理，可以加载网络图片
                    logging: true, // 日志开关
                }

                html2canvas(shareContent, options).then((canvass) => {
                    // 生成图片地址
                    let imgUrl = canvass.toDataURL();
                    let obj = {
                        "budgetMainId": this.budgetMainId,
                        "imageBase64": imgUrl.split(',')[1]
                    }
                    new PlanApi('plan').mapAdd(obj).then(res => {
                        if (res.status == 200) {
                            this.$message.success('保存成功...')
                            this.$emit("allowExport")
                        }
                    })
                });
            }
        },
        // 下载图片
        init() {
            this.planMapShow = true
            this.$nextTick(() => {
                getPlanInfo(this.planId, this.budgetMainId)
                setTimeout(() => {
                    this.$refs.createPlanMap.initMap(true);
                }, 1000);
            })
        },

        redirectInit() {
            this.$Bus.$on('changePlanInfo', data => {
                console.log(data,'是看看打开时刻打开111111');
                
                this.chenckBudget = data.budgetMain
                this.mapCityArr = []
                this.chenckBudget.planDayList.forEach(item => {
                    let cityArr = [...(item.cityList.filter(u => u.longitude !== '' && u.latitude !== ''))]
                    let _filterCitys = cityArr.filter(u => u.countryId == 8)
                    if (_filterCitys.length < 2) {
                        this.mapCityArr.push(...cityArr.filter(u => u.countryId != 8))
                    } else {
                        this.mapCityArr.push(...cityArr)
                    }
                })
                console.log( this.mapCityArr,'l啦啦啦数量多');
                
                // this.mapCityArr = groupBy(this.mapCityArr, "cityId")
                if (this.mapCityArr.length > 1) {
                    this.modalShow = true
                } else {
                    this.screenshot()
                }
            })
        },

        close() {
            this.planMapShow = false
        }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.redirectInit()
    },
    beforeCreate() {
    }, // 生命周期 - 创建之前
    beforeMount() {
    }, // 生命周期 - 挂载之前
    beforeUpdate() {
    }, // 生命周期 - 更新之前
    updated() {
    }, // 生命周期 - 更新之后
    beforeDestroy() {

    }, // 生命周期 - 销毁之前
    destroyed() {
    }, // 生命周期 - 销毁完成
    activated() {
    }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped lang="scss">
.el-dialog__wrapper {
    z-index: 10000 !important;
}

.download {
    position: absolute;
    z-index: 1000;
    right: 17px;
    top: 9px;
    text-decoration: underline;
    text-underline-offset: 4px;

    &:hover {
        cursor: pointer;
        color: red;
    }
}

/deep/ .el-dialog {
    margin-top: 10vh !important;
    width: 98vw !important;
}

/deep/ .el-dialog__body {
    padding: 0;
}

/deep/ .el-dialog__header {
    display: none;
}

.photo {
    position: absolute;
    right: 8px;
    z-index: 9999;
    font-size: 30px;
    top: 7px;
    color: #db4e1a;
    font-size: 700;
}

/deep/ .createPlanMap {
    #Create-Plan-Map {
        //max-height: 402px;
        border-radius: 10px 10px 0px 0px;
    }
}
</style>